import { MarketStatusPill } from '~/features/shared/market-content';
import type { MsaasJobListing } from '~/types/hlx/msaasJobListing';
import { SUPPORT_EMAIL } from '../listingConflicts';
import { LIFECYCLE_LABEL, listingLifecycle, supportCancelMailto } from './listingLifecycle';

const PILL_STATUS = {
  CANCELLED: 'inactive',
  FILLED_BY_CONTRACT: 'neutral',
  FILLED: 'neutral',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

// [MCV-1889] Where a listing is in its life. A contract-filled listing has no Cancel: cancelling it
// cancels the contract, which support does (DD24).
export const ListingStatusCell = ({ listing }: { listing: MsaasJobListing }) => {
  const lifecycle = listingLifecycle(listing);
  return (
    <div className="flex flex-col items-start gap-1" data-cy={`listing-status-${listing.id}`}>
      <MarketStatusPill status={PILL_STATUS[lifecycle]} label={LIFECYCLE_LABEL[lifecycle]} />
      {lifecycle === 'CANCELLED' && listing.relistedAsListingId != null && (
        <span className="text-xs text-content-secondary">
          Cancelled · Relisted as #{listing.relistedAsListingId}
        </span>
      )}
      {lifecycle === 'FILLED_BY_CONTRACT' && (
        <span className="max-w-[260px] text-xs text-content-secondary">
          Need to cancel? Cancelling a filled listing cancels its contract. Contact{' '}
          <a className="underline" href={supportCancelMailto(listing)}>
            {SUPPORT_EMAIL}
          </a>
          .
        </span>
      )}
    </div>
  );
};
